import createRestfulModule from './restful-module'

export default createRestfulModule({

  state: {
    path: 'companies', // 资源路径
  },

})
